import { $authHost } from '.'
import {
	ElectricMechanic,
	ElectricMechanicValue,
	Record,
	RecordStatus,
	Relay,
	RelayOne,
	RelayType
} from '../helpers/types/relay'

export type JournalRecordItem = Pick<
	Record,
	| 'id'
	| 'relayTypeId'
	| 'relayId'
	| 'mechanicValues'
	| 'electricValues'
	| 'status'
	| 'createdAt'
	| 'relayOne'
	| 'relay'
	| 'mechanicByUser'
	| 'electricByUser'
	| 'approvedByUser'
>

export type JournalRecordsResponse = {
	data: JournalRecordItem[]
	total: number
}

export const createRelayType = async (relayType: RelayType) => {
	const { data } = await $authHost.post('/relay-type/', relayType)
	return data as RelayType
}

export const createRelay = async (relay: Relay) => {
	const { data } = await $authHost.post('/relay/', relay)
	return data as Relay
}

export const createRelayOne = async (relay: RelayOne) => {
	const { data } = await $authHost.post('/relay-one/', relay)
	return data as RelayOne
}

export const createRecord = async (
	record: Omit<Record, 'mechanicValues' | 'electricValues'>
) => {
	const { data } = await $authHost.post('/record/', record)
	return data as Record
}

export const createMechanic = async (relay: ElectricMechanic) => {
	const { data } = await $authHost.post('/mechanic/', relay)
	return data as ElectricMechanic
}

export const createElectric = async (relay: ElectricMechanic) => {
	const { data } = await $authHost.post('/electric/', relay)
	return data as ElectricMechanic
}

export const createMechanicValue = async (
	relay: ElectricMechanicValue[]
) => {
	const { data } = await $authHost.post('/mechanic-value/', relay)
	return data as ElectricMechanicValue[]
}

export const createElectricValue = async (
	relay: ElectricMechanicValue[]
) => {
	const { data } = await $authHost.post('/electric-value/', relay)
	return data as ElectricMechanicValue[]
}

export const fetchRelayTypes = async () => {
	const { data } = await $authHost.get('/relay-type/')
	return data as RelayType[]
}

export const fetchRelaysByType = async (relayTypeId: string) => {
	const { data } = await $authHost.get('/relay-type/' + relayTypeId)
	return data as RelayType
}

export const fetchRelayOnesByRelayId = async (relayId: string) => {
	const { data } = await $authHost.get('/relay-one/' + relayId)
	return data as RelayOne[]
}

export const fetchMechanicByType = async (relayTypeId: string) => {
	const { data } = await $authHost.get('/mechanic/' + relayTypeId)
	return data as RelayType
}

export const fetchElectricByType = async (relayTypeId: string) => {
	const { data } = await $authHost.get('/electric/' + relayTypeId)
	return data as RelayType
}

export const fetchRelayOneRecords = async (
	relayTypeId: string,
	relayId: string,
	relayOneId: string,
	page: number
) => {
	const { data } = await $authHost.get(
		'/record/' +
			relayTypeId +
			'/' +
			relayId +
			'/' +
			relayOneId +
			'?page=' +
			page
	)
	return data as Record[]
}

export const fetchRelayOneRecordOne = async (
	relayTypeId: string,
	relayId: string,
	relayOneId: string,
	recordId: string
) => {
	const { data } = await $authHost.get(
		'/record/' +
			relayTypeId +
			'/' +
			relayId +
			'/' +
			relayOneId +
			'/' +
			recordId
	)
	return data as Record
}

export const fetchRelayOneMechanicValue = async (
	relayOneId: string
) => {
	const { data } = await $authHost.get(
		'/mechanic-value/relay-one/' + relayOneId
	)
	return data as ElectricMechanicValue[]
}

export const fetchRelayOneElectricValue = async (
	relayOneId: string
) => {
	const { data } = await $authHost.get(
		'/electric-value/relay-one/' + relayOneId
	)
	return data as ElectricMechanicValue[]
}

export const checkRecordMechanicValue = async (
	relayTypeId: string,
	relayId: string,
	relayOneId: string,
	recordId: string
) => {
	const { data } = await $authHost.get(
		'/mechanic-value/check/' +
			relayTypeId +
			'/' +
			relayId +
			'/' +
			relayOneId +
			'/' +
			recordId
	)
	return data as { dublicate: boolean }
}

export const checkRecordElectricValue = async (
	relayTypeId: string,
	relayId: string,
	relayOneId: string,
	recordId: string
) => {
	const { data } = await $authHost.get(
		'/electric-value/check/' +
			relayTypeId +
			'/' +
			relayId +
			'/' +
			relayOneId +
			'/' +
			recordId
	)
	return data as { dublicate: boolean }
}

export const getRecordsJournal = async (
	page: number,
	relayTypeId?: string
) => {
	const params = new URLSearchParams({
		page: String(page)
	})

	if (relayTypeId) {
		params.set('relayTypeId', relayTypeId)
	}

	const { data } = await $authHost.get(
		'/record/journal?' + params.toString()
	)
	return data as JournalRecordsResponse
}

export const updateRelayType = async (relayType: RelayType) => {
	const { data } = await $authHost.put(
		'/relay-type/' + relayType.id,
		{
			...relayType
		}
	)
	return data as RelayType
}

export const updateRelay = async (relay: Relay) => {
	const { data } = await $authHost.put('/relay/' + relay.id, {
		...relay
	})
	return data as Relay
}

export const updateRelayOne = async (relay: RelayOne) => {
	const { data } = await $authHost.put('/relay-one/' + relay.id, {
		...relay
	})
	return data as RelayOne
}

export const updateMechanic = async (relay: ElectricMechanic) => {
	const { data } = await $authHost.put('/mechanic/' + relay.id, {
		...relay
	})
	return data as ElectricMechanic
}

export const updateElectric = async (relay: ElectricMechanic) => {
	const { data } = await $authHost.put('/electric/' + relay.id, {
		...relay
	})
	return data as ElectricMechanic
}

export const deleteRelayType = async (relayTypeId: string) => {
	const { data } = await $authHost.delete(
		'/relay-type/' + relayTypeId
	)
	return data as RelayType
}

export const deleteRelay = async (relayId: string) => {
	const { data } = await $authHost.delete('/relay/' + relayId)
	return data as Relay
}

export const deleteMechanic = async (mechanicId: string) => {
	const { data } = await $authHost.delete('/mechanic/' + mechanicId)
	return data as ElectricMechanic
}

export const deleteElectric = async (electricId: string) => {
	const { data } = await $authHost.delete('/electric/' + electricId)
	return data as ElectricMechanic
}

export interface UpdateRecordStatusBody {
	status: RecordStatus
	rejectionReason?: string
}

export const updateRecordStatus = async (
	recordId: string,
	body: UpdateRecordStatusBody
): Promise<Record> => {
	const { data } = await $authHost.patch(
		`/record/${encodeURIComponent(recordId)}/status`,
		body
	)
	return data as Record
}

export interface JournalReportParams {
	relayId: string
	startDate: string
	endDate: string
}

export const downloadJournalReport = async (
	params: JournalReportParams
): Promise<void> => {
	const query = new URLSearchParams({
		relayId: params.relayId,
		startDate: params.startDate,
		endDate: params.endDate
	})

	const response = await $authHost.get(
		`/reports/journal?${query.toString()}`,
		{ responseType: 'blob' }
	)

	const url = URL.createObjectURL(response.data as Blob)
	const a = document.createElement('a')
	a.href = url
	a.download = `journal-${params.relayId}-${params.startDate}-${params.endDate}.pdf`
	a.click()
	URL.revokeObjectURL(url)
}

export const fetchRecordPdfUrl = async (
	recordId: string
): Promise<string | null> => {
	const { data } = await $authHost.get(
		`/record/${encodeURIComponent(recordId)}/pdf`
	)
	return (data as { signedUrl?: string | null }).signedUrl ?? null
}
